import { UnifiedAccountIntegrationsServiceComponent } from './UnifiedAccountIntegrationsServiceComponent';
export const UnifiedAccountIntegrationsReconnectionConfig = {
  serviceComponent: UnifiedAccountIntegrationsServiceComponent
};